import RecentGames from "./RecentGames";

export default RecentGames;